import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Sticker = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z" />
        <path d="M14 3v4a2 2 0 0 0 2 2h4" />
        <path d="M8 13h.01" />
        <path d="M16 13h.01" />
        <path d="M10 16s.8 1 2 1c1.3 0 2-1 2-1" />
      </svg>
    );
  },
);

export default Sticker;
